module.exports = __webpack_public_path__ + "static/media/frame-img.01c75e3a.png";